import React from 'react';

function Contact() {
  return (
    <section className="medolia-booking-sec pt-130 pb-80">
      <div className="container">
        <div className="row">
          {/* Contact Info */}
            <div className="col-lg-5 mb-5 mb-lg-0">
              <div className="contact-info-box p-4 bg-light rounded h-100">
                <h4 className="mb-4">Contact Information</h4>
                
                <div className="contact-item mb-4 d-flex">
                  <i className="fas fa-map-marker-alt text-orange fs-4 me-3 mt-1"></i>
                  <div>
                    <h6>Our Office</h6>
                    <p className="mb-0 text-muted">
                      Plot 688 Ahmodu Tijani Close,<br />
                      Off Sanusi Fafunwa Street,<br />
                      Victoria Island, Lagos State, Nigeria
                    </p>
                  </div>
                </div>

                <div className="contact-item mb-4 d-flex">
                  <i className="fas fa-phone text-orange fs-4 me-3 mt-1"></i>
                  <div>
                    <h6>Phone</h6>
                    <p className="mb-0 text-muted">+234 (815) 159-0112</p>
                    <small className="text-muted">Mon-Fri, 9am-6pm WAT</small>
                  </div>
                </div>

                <div className="contact-item mb-4 d-flex">
                  <i className="fas fa-envelope text-orange fs-4 me-3 mt-1"></i>
                  <div>
                    <h6>Email</h6>
                    <p className="mb-0 text-muted">info@fsl.ng</p>
                    <small className="text-muted">We respond within 24 hours</small>
                  </div>
                </div>

                <div className="contact-item d-flex">
                  <i className="fas fa-clock text-orange fs-4 me-3 mt-1"></i>
                  <div>
                    <h6>Support Hours</h6>
                    <p className="mb-0 text-muted">24/7 Emergency Support for Partners</p>
                  </div>
                </div>

                <div className="mt-5">
                  <h6 className="mb-3">Follow Us</h6>
                  <div className="social-links d-flex gap-3">
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-orange fs-5"><i className="fab fa-facebook-f"></i></a>
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-orange fs-5"><i className="fab fa-twitter"></i></a>
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-orange fs-5"><i className="fab fa-linkedin-in"></i></a>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-orange fs-5"><i className="fab fa-instagram"></i></a>
                  </div>
                </div>
              </div>
            </div>
          <div className="col-lg-6">
            <div className="booking-wrapper" data-aos="fade-up" data-aos-duration="1400">
              <h3>Get in Touch</h3>
              <form className="booking-form">
                <div className="row">
                  <div className="col-lg-6"><div className="form-group"><input type="text" className="form_control" placeholder="Full Name" name="name" required /></div></div>
                  <div className="col-lg-6"><div className="form-group"><input type="email" className="form_control" placeholder="Email Address" name="email" required /></div></div>
                  <div className="col-lg-6"><div className="form-group"><input type="text" className="form_control" placeholder="Company Name" name="company" required /></div></div>
                  <div className="col-lg-6"><div className="form-group"><input type="tel" className="form_control" placeholder="Phone Number" name="phone" required /></div></div>
                  <div className="col-lg-12"><div className="form-group"><textarea className="form_control" placeholder="Message" name="message" rows="4" required></textarea></div></div>
                  <div className="col-lg-12"><div className="form-group mt-20"><button className="theme-btn style-one">Send Message</button></div></div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;